import { Action, createReducer, on } from '@ngrx/store';
import { Customer, CustomerDTO } from '../../commons/models/customer';
import * as CustomersActions from '../actions/customers.actions';
import { CustomersFilters } from '../../commons/models/customer';
import { Tenants } from '../../commons/models/tenants';

export interface CustomersState {
  list: CustomerDTO[],
  total: number,
  currentPage: number,
  includes: string[],
  perPage: number,
  order: string,
  direction: string,
  filters: CustomersFilters,
  dialogId: string,
  selectionDialogId: string,
  customer: Customer,
  tenants: Tenants[],
  selectedCustomers: Customer[]
};

const initialState: CustomersState = {
  list: [],
  total: 0,
  currentPage: 1,
  perPage: 25,
  includes: [],
  order: null,
  direction: null,
  filters: null,
  dialogId: null,
  selectionDialogId: null,
  customer: null,
  tenants: [],
  selectedCustomers: []
};

const customerReducer = createReducer(
    initialState,
    on(CustomersActions.loadCustomersCompleted, (state, { customers, currentPage, total, perPage, order, direction, filters, includes }) => {
        return { ...state, list: customers, currentPage, total, perPage, order, direction, filters, includes };
    }),
    on(CustomersActions.customerDialogOpened, (state, { dialogId }) => {
        return { ...state, dialogId };
    }),
    on(CustomersActions.changeFilters, (state, { filters }) => {
        return { ...state, currentPage: 1, filters };
    }),
    on(CustomersActions.selectionDialogOpened, (state, { selectionDialogId }) => {
        return { ...state, selectionDialogId };
    }),
    on(CustomersActions.selectCustomer, (state, { filters, currentFormControlName }) => {
        return { ...state, currentPage: 1, filters, currentFormControlName };
    }),
);

export function reducer(state: CustomersState | undefined, action: Action) {
    return customerReducer(state, action);
}